
import React from 'react';

const Footer = () => (
  <section className="footer">
    <div>
      <h2>Advogado em Curitiba</h2>    

    </div>
  </section>
);

export default Footer;